export default "__VITE_ASSET__DzVxdQDt__"